<div class="nxe-explorer" [class.nxe-explorer--tree-closed]="!treeOpen">
    <div class="nxe-explorer-left">
        <!-- visibile solo sotto i 900px: apre/chiude l'elenco cartelle sopra il contenuto -->
        <button type="button" class="xr-btn xr-btn--secondary xr-btn--small nxe-explorer-tree-toggle"
                (click)="toggleTree()" aria-controls="nxe-explorer-tree" [attr.aria-expanded]="treeOpen">
            <i-tabler class="icon-18" name="folder"></i-tabler>
            <span>{{ 'filemanager.ui.folders' | translate }}</span>
            <i-tabler class="icon-16 nxe-explorer-tree-toggle-chevron" [name]="treeOpen ? 'chevron-up' : 'chevron-down'"></i-tabler>
        </button>
        <div class="nxe-explorer-tree" id="nxe-explorer-tree">
            <nxe-tree></nxe-tree>
        </div>
    </div>
    <div class="nxe-explorer-right">
        <nxe-content [showSwitcher]="showSwitcher" [showSendFile]="showSendFile" [showEditFile]="showEditFile"></nxe-content>
    </div>
</div>
